<template>
	<div class="input__wrapper" @input="passwordCheck">
		<label :class="data.labelClass">
			<span class="input-label" :id="data.labelId">{{ data.label }}<span class="input__wrapper-mandatory" v-if="data.mandatoryFiled">*</span></span>

			<input
				ref="input"
				:type="data.type"
				:id="data.inputId"
				:name="data.name"
				:minlength="data.minlength"
				:placeholder="data.placeholder"
				:class="data.classinput"
				v-model="inputVal"
				:required="data.required"
				:disabled="data.disabled ? data.disabled : false"
				@change="checkType($event)"
				@keydown="checkType($event)"
				@keyup="capitalLetter($event)"
			/>
		</label>
	</div>
</template>

<script>
import { allowOnlyNumbersGlobal, formatPhone, formatPrice } from '@/config/util';

export default {
	props: {
		data: {
			type: Object,
			required: true
		}
	},
	data () {
		return {
			inputVal: this.value
		};
	},
	watch: {
		inputVal (val) {
			this.$emit('input', val);
		}
	},
	methods: {
		setValue(value) {
			this.inputVal = value;
		},
		allowOnlyNumbers(event) {
			allowOnlyNumbersGlobal(event);
		},
		passwordCheck() {
			this.$emit('checkPassword');
		},
		checkType(event) {
			if (this.data.type === 'number') {
				return this.allowOnlyNumbers(event);
			} else if (this.data.type === 'phone') {
				return formatPhone(event);
			} else if (this.data.type === 'price') {
				return formatPrice(event);
			}
			return '';
		},
		capitalLetter(event) {
			this.$emit('capitalLetter', event);
		}
	}
};
</script>

<style lang="scss" scoped>
.input__wrapper {
	input {
		display: block;
		box-shadow: none;
		border: 1px solid $white-lilac;
		border-radius: 14px;
		padding: 14px 16px;
		max-width: 100%;
		line-height: 1.2;
		width: 100%;
		font-size: 14px;
		font-family: $font-main;
		color: $fiord;
		transition: $dur $ease;
		text-overflow: ellipsis;
		overflow: hidden;
		white-space: nowrap;
		background-color: $white-lilac;

		@include mq($sm) {
			font-size: 16px;
			padding: 13px;
		}

		&:focus {
			border: 1px solid $dodger-blue;
		}

		@include placeholder {
			color: $grey;
		}

		&.input--capitalize {
			text-transform: capitalize;
		}
	}
}
</style>
